var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Component } from '../../../lib/dom';
import './Leaderboard.less';
var Leaderboard = /** @class */ (function (_super) {
    __extends(Leaderboard, _super);
    function Leaderboard(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Leaderboard';
        _this.el = _this.DIV('&');
        return _this;
    }
    Leaderboard.prototype.setEntries = function (entries, userRank) {
        this.el.appendChild(this.mapEntries(entries, userRank), true);
        this.scrollToActive();
    };
    Leaderboard.prototype.clear = function () {
        this.el.appendChild(this.DIV('&__entries'), true);
    };
    Leaderboard.prototype.mapEntries = function (entries, userRank) {
        var Entry = this.props.Entry;
        return this.DIV({}, [
            this.DIV('&__entries', __spreadArray([], entries.map(function (entry, index) {
                return new Entry({
                    active: entry.rank === userRank,
                    border: index > 0 && entry.rank - entries[index - 1].rank > 1,
                    entry: entry,
                });
            }), true)),
        ]);
    };
    Leaderboard.prototype.scrollToActive = function () {
        var _this = this;
        var querySelector = function (selector) { return _this.el.valueOf().querySelector(selector); };
        var active = querySelector('.Entry_active');
        var first = querySelector('.Entry:nth-child(1)');
        var list = querySelector('.Leaderboard__entries');
        if (first && active && first !== active && list) {
            var firstRect = first.getBoundingClientRect();
            list.scrollTop = active.getBoundingClientRect().y - firstRect.y - firstRect.height;
        }
    };
    return Leaderboard;
}(Component));
export { Leaderboard };
